import React, { useEffect, useState } from "react";
import AccessTimeRoundedIcon from "@material-ui/icons/AccessTimeRounded";
import LanguageRoundedIcon from "@material-ui/icons/LanguageRounded";
import styles from "../Footer/Footer.module.css";
import { useTimezone, getTimezoneOption } from "../../Context/TimezoneContext";

// Same fixed bottom bar as the regular Footer.js (reuses its CSS module
// directly), minus the FabButton - that drags in usePermissions()/
// PermissionsContext, which this standalone SuperAdmin shell (isolated from
// the store-admin NavDrawer/permissions tree on purpose) doesn't provide.
const SuperAdminFooter = () => {
  const [now, setNow] = useState(() => new Date());
  const { timezone, formatInTimezone } = useTimezone();
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // Whatever's currently selected in the nav bar's dropdown (starts on this
  // device's own system zone, then whatever the SuperAdmin explicitly
  // switches to) - unlike the public Footer.js, this always reflects the
  // selection, not the raw device zone, once they've changed it.
  const selectedOption = getTimezoneOption(timezone);

  return (
    <footer className={`${styles.footer} ${styles.superAdminFooter}`}>
      <div className={styles.content}>
        <span className={styles.statusDot} aria-hidden="true" />
        <span>
          Powered by <strong>Mindtree Technologies Co. Ltd.</strong>
        </span>
      </div>

      {selectedOption && (
        <div className={styles.timezone} title={timezone} aria-label={`Display timezone: ${timezone}`}>
          <LanguageRoundedIcon className={styles.zoneIcon} />
          <span>{selectedOption.city.split(",")[0]}</span>
          <span className={styles.zoneOffset}>{selectedOption.offset}</span>
        </div>
      )}

      <div className={styles.clock} aria-label={`Current date and time (${timezone})`}>
        <AccessTimeRoundedIcon className={styles.clockIcon} />
        <span className={styles.clockDate}>{formatInTimezone(now, "MMM DD, YYYY")}</span>
        <span className={styles.clockDivider}>•</span>
        <span className={styles.clockTime}>{formatInTimezone(now, "hh:mm:ss A")}</span>
        {selectedOption && (
          <>
            <span className={styles.clockDivider}>•</span>
            <span className={styles.clockZone} title={timezone}>
              {selectedOption.city.split(",")[0]} ({selectedOption.offset})
            </span>
          </>
        )}
      </div>
    </footer>
  );
};

export default SuperAdminFooter;
